import React, { useEffect, useState } from 'react'
import { HelpCircle as HelpCircleIcon } from 'react-feather'
import { Button, Container } from '@material-ui/core'
import { isEmpty } from 'lodash'

import {
  ContentHeader,
  DriveTour,
  // DialogLogs,
  LoadingFeedback,
  // MenuButton,
  Page,
} from 'components'
import { Form } from './components'

import useFetch from 'hooks/useFetch'
import useIncidentManegement from 'hooks/useIncidentManegement'
import useConvertToFile from 'hooks/useConvertToFile'

import constants from 'constants/index'
import * as service from 'service'
import incidentManegementConstants from 'constants/incidentManegement'

import helpers from 'helpers'

const IncidentManagementShow = ({ match }) => {
  const [openTour, setOpenTour] = useState(false)
  // const [openLogDialog, setOpenLogDialog] = useState(false)
  // const [responseLogWithStatus, setResponseLogWithStatus] = useState([])
  // const [loadingLogs, setLoadingLogs] = useState(false)

  const { incident, setIncident, setActiveStep, activeStep } =
    useIncidentManegement()
  const { fileList, loading } = useConvertToFile(incident?.detectionAttachments)

  const { incidentId } = match.params

  const { response, isLoading, refresh } = useFetch(
    service.dponet.incidents.get,
    {
      incidentId,
    },
  )

  const identifyCurrentStep = (incidentManegementSteps) => {
    const stepsByEnum = incidentManegementConstants.ORDER_BY_ENUM

    if (isEmpty(incidentManegementSteps)) return

    incidentManegementSteps.forEach((incidentManegementStep) => {
      incidentManegementStep.order = stepsByEnum[incidentManegementStep.step]
    })

    incidentManegementSteps = incidentManegementSteps.sort(
      (a, b) => a.order - b.order,
    )

    const firstUnconcludedStep = incidentManegementSteps.find(
      (incidentManegementStep) => !incidentManegementStep.concluded,
    )

    if (isEmpty(firstUnconcludedStep))
      return setActiveStep(stepsByEnum['lessons_learned'])

    setActiveStep(firstUnconcludedStep.order)
  }

  const currentStep = helpers.incidents.incidentManegementSteps(incident, true)[
    activeStep
  ]

  const handleOpenTour = () => {
    const where = 'Incidentes'
    const title = 'Tour'

    const params = {
      action: 'tour-editar-incidente',
    }

    helpers.mixpanel.track(where, title, params)
    setOpenTour(true)
  }

  useEffect(() => {
    if (response?.data?.incident) {
      if (isEmpty(incident)) {
        identifyCurrentStep(response.data.incident?.incidentManegementSteps)
      }

      setIncident(response.data.incident)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [response?.data?.incident])

  // useEffect(() => {
  //   const getLogs = async () =>
  //     await service.dponet.incidents.logs({
  //       incidentId,
  //     })

  //   if (isEmpty(responseLogWithStatus) && openLogDialog) {
  //     setLoadingLogs(true)
  //     getLogs().then((response) => {
  //       const updatedLogs = helpers.logs.changeLogs(
  //         response?.data?.dponetAudits || [],
  //       )
  //       setResponseLogWithStatus(updatedLogs)
  //       setLoadingLogs(false)
  //     })
  //   }

  //   // eslint-disable-next-line
  // }, [openLogDialog])

  useEffect(() => {
    if (!isEmpty(incident) && !loading)
      setIncident((prevIncident) => ({
        ...prevIncident,
        detectionAttachmentsList: fileList,
      }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fileList, loading])

  return (
    <Page title="Visualizar incidente">
      <Container maxWidth={false}>
        <ContentHeader title="Visualizar Incidente" breakLine={false}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<HelpCircleIcon size={20} />}
            onClick={handleOpenTour}
            id={constants.incidents.INCIDENT_MAIN_DRIVER_STEP_0}
            fullWidth
          >
            Tutorial
          </Button>
          {/*<MenuButton>
            <Button
              color="secondary"
              fullWidth
              onClick={() => setOpenLogDialog(true)}
            >
              Histórico de alterações
            </Button>
          </MenuButton>*/}
        </ContentHeader>

        <LoadingFeedback
          open={
            isLoading
            //  || loadingLogs
          }
        />

        {((!isLoading && !loading) || !isEmpty(incident)) && (
          <Form refresh={refresh} />
        )}
      </Container>

      {/* {!loadingLogs && (
        <DialogLogs
          logs={
            helpers.functions.isEmpty(responseLogWithStatus)
              ? undefined
              : responseLogWithStatus
          }
          open={openLogDialog}
          setOpen={setOpenLogDialog}
          showRegisterSession={false}
        />
      )} */}
      <DriveTour
        stepsMatrix={helpers.incidents.driverJs.chooseStepsObject(currentStep)}
        open={openTour}
        setOpen={setOpenTour}
      />
    </Page>
  )
}

export default IncidentManagementShow
